import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GtmTrackerService {
  constructor(private router: Router) {
    this.trackPageViews();
  }

  private trackPageViews() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const pageEvent = {
          event: 'page',
          pageName: event.urlAfterRedirects,
        };

        (window as any).dataLayer?.push(pageEvent);
      });
  }
}
